import { type MouseEvent } from 'react'

type CallbackFunction<EventType> = (event: EventType) => void

export function executeClickHandlers<EventType>(
  ...callbacks: CallbackFunction<EventType>[]
) {
  return (evt: EventType) => {
    callbacks.forEach((callback) => {
      callback(evt)
    })
  }
}

export function stopClickPropagation<
  EventType extends MouseEvent<HTMLButtonElement | HTMLDivElement>,
>(callback?: CallbackFunction<EventType>) {
  return (evt: EventType) => {
    evt.stopPropagation()
    callback?.(evt)
  }
}
